import { writable, get } from "svelte/store";
export default class UrlParameter {
    static Get(key, deflt) {
        if (!this.initialized) {
            this.init();
        }
        if (deflt !== undefined) {
            UrlParameter.defaults[key] = deflt;
        }
        if (UrlParameter.knownSources[key] !== undefined) {
            return UrlParameter.knownSources[key];
        }
        const source = writable(deflt);
        UrlParameter.knownSources[key] = source;
        source.subscribe(() => {
            UrlParameter.Serialize();
        });
        return source;
    }
    static init() {
        var _a;
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        if ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) {
            const params = window.location.search.substr(1).split("&");
            for (const param of params) {
                const kv = param.split("=");
                const key = decodeURIComponent(kv[0]);
                const v = decodeURIComponent(kv[1]);
                if (!window.location.pathname.endsWith("callback") && UrlParameter.blacklist.indexOf(key) >= 0) {
                    continue;
                }
                const source = writable(v);
                UrlParameter.knownSources[key] = source;
                source.subscribe(_ => {
                    UrlParameter.Serialize();
                });
            }
        }
    }
    static Serialize() {
        var _a;
        const parts = [];
        for (const key in this.knownSources) {
            const source = this.knownSources[key];
            const value = (_a = get(source)) !== null && _a !== void 0 ? _a : this.defaults[key];
            if (value === undefined) {
                continue;
            }
            if (value === "undefined") {
                continue;
            }
            if (value === UrlParameter.defaults[key]) {
                continue;
            }
            parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
        }
        // Don't pollute the history every time a parameter changes
        history.replaceState(null, "", "?" + parts.join("&") + window.location.hash);
    }
    static GetAny(key, deflt, base64 = false) {
        function encode(t) {
            if (t === undefined) {
                return undefined;
            }
            let str = JSON.stringify(t);
            if (base64) {
                str = window.btoa(str);
            }
            return str;
        }
        function decode(s) {
            if (s === undefined) {
                return undefined;
            }
            if (base64) {
                s = window.atob(s);
            }
            try {
                return JSON.parse(s);
            }
            catch (e) {
                console.error(e, "Could not parse json");
                return undefined;
            }
        }
        const stringStore = UrlParameter.Get(key, encode(deflt));
        const parsedStore = writable(decode(get(stringStore)));
        // There probably is a two-way sync somewhere in the svelte library... Feel free to replace the code below with it
        stringStore.subscribe(param => {
            parsedStore.set(decode(param));
        });
        parsedStore.subscribe(t => {
            stringStore.set(encode(t));
        });
        return parsedStore;
    }
}
UrlParameter.knownSources = {};
UrlParameter.initialized = false;
UrlParameter.defaults = {};
/**
 * Don't handle these URL-parameters, they are handled by the authentication code
 */
UrlParameter.blacklist = ["session_state", "scope", "code"];
